import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/product/$id")({
  component: lazyRouteComponent(() => import("./product.$id.lazy")),
});
